import { ChangeEventHandler, useEffect, useState } from "react";
import { LocationData } from "../../../../types/location";
import { SITE_DATA_PARTITIONS } from "../../../../types/siteTable";
import generators from "../../../../shared-utils/noDep/generators";
import { Input } from "./components";
import { Button } from "../Button";
import { deliveryLocationRequiredParams } from "../../../../types";

export const AddressForm = (props: {
  onSubmit: (locationData: LocationData) => Promise<void>;
  values?: Partial<LocationData>;
}) => {
  const [locationData, setLocationData] = useState<
    Partial<LocationData> | undefined
  >(
    props.values ?? {
      type: SITE_DATA_PARTITIONS.LOCATION,
      countryCode: "US",
      slug: generators.randomNumberString(15),
    },
  );
  const [locationErrors, setLocationErrors] = useState<
    Partial<Record<keyof LocationData, string>>
  >({});

  useEffect(() => {
    props.values && setLocationData(props.values);
  }, [props.values]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const handleChange: ChangeEventHandler<
    HTMLInputElement & HTMLSelectElement
  > = (evt) => {
    const { value, name } = evt.target;
    setLocationData((d) => ({ ...d, [name]: value }));

    if (
      deliveryLocationRequiredParams.includes(
        name as (typeof deliveryLocationRequiredParams)[number],
      ) &&
      value.trim() === ""
    ) {
      setLocationErrors((e) => ({ ...e, [name]: "Please include " + name }));
    } else {
      setLocationErrors((e) => ({ ...e, [name]: undefined }));
    }
  };
  return (
    <div>
      <Input
        label="Name"
        value={locationData?.addressee}
        name="addressee"
        onChange={handleChange}
        error={locationErrors?.addressee}
      />
      <Input
        label="Address Line"
        value={locationData?.addressLine}
        name="addressLine"
        onChange={handleChange}
        error={locationErrors?.addressLine}
      />
      <Input
        label="City"
        value={locationData?.city}
        name="city"
        onChange={handleChange}
        error={locationErrors?.city}
      />
      <div className="flex flex-col xl:flex-row">
        <Input
          label="State"
          value={locationData?.state}
          name="state"
          onChange={handleChange}
          error={locationErrors?.state}
        />
        <Input
          label="Zip code"
          value={locationData?.zip}
          name="zip"
          onChange={handleChange}
          error={locationErrors?.zip}
        />
      </div>

      <Input
        inputType="select"
        label="Country"
        value={locationData?.countryCode}
        name="countryCode"
        onChange={handleChange}
        error={locationErrors?.countryCode}
      >
        <option value="US">US</option>
      </Input>
      <Button
        type="submit"
        disabled={isLoading}
        onClick={() => {
          const missingParams = deliveryLocationRequiredParams.filter(
            (key) => locationData?.[key]?.trim() === "",
          );
          console.log("miss", missingParams);
          if (missingParams.length) {
            setLocationErrors((e) => ({
              ...e,
              ...Object.fromEntries(
                missingParams.map((key) => [key, "Please include " + key]),
              ),
            }));
            return;
          }
          setIsLoading(true);
          locationData &&
          locationData.type === SITE_DATA_PARTITIONS.LOCATION &&
          locationData.slug
            ? props
                .onSubmit({
                  ...(locationData as LocationData),
                })
                .finally(() => {
                  setIsLoading(false);
                })
            : undefined;
        }}
        btnType={"small"}
        btnColor={"primary"}
      >
        Submit
      </Button>
    </div>
  );
};
